module.exports = __webpack_public_path__ + "fonts/PingFangSC-Semibold.fd6499b6.ttf";